import { Icon } from '../ui/index.js';
import { useTheme } from './ThemeContext.js';

export function ThemeToggle() {
  const { resolvedTheme, toggle } = useTheme();
  const isDark = resolvedTheme === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Passa al tema chiaro' : 'Passa al tema scuro'}
      title={isDark ? 'Tema chiaro' : 'Tema scuro'}
      className="flex h-10 w-10 items-center justify-center rounded-xl border border-outline bg-surface-container-lowest text-on-surface-variant transition-all hover:border-on-surface-variant/40 hover:text-cyan"
    >
      <Icon name={isDark ? 'light_mode' : 'dark_mode'} className="text-base" />
    </button>
  );
}
